import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/constants/services";

export default function Services({ onBook }) {
  return (
    <section
      id="services"
      className="py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="services-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="mb-20 flex flex-wrap items-end justify-between gap-8"
      >
        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-[#d4af37] mb-6">
            Services
          </p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            Ten ways to travel well.
          </h2>
        </div>
        <p className="max-w-sm text-base leading-relaxed tracking-wide text-[#888]">
          Every service books the same way — choose yours, tell us when, and
          Daniel confirms personally by phone or email.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.slug}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
            className="group border border-white/10 p-8 flex flex-col hover:border-[#d4af37]/50 transition-colors duration-500"
            data-testid={`service-card-${s.slug}`}
          >
            <span className="font-serif-lux text-4xl font-light text-[#d4af37]/40 group-hover:text-[#d4af37] transition-colors duration-500">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-6 font-serif-lux text-2xl font-light tracking-tight">
              {s.title}
            </h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed tracking-wide text-[#888]">
              {s.desc}
            </p>
            {s.includes && (
              <ul className="mt-4 space-y-1.5">
                {s.includes.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-2.5 text-[11px] tracking-[0.15em] uppercase text-[#aaa]"
                  >
                    <span className="w-1 h-1 rotate-45 bg-[#d4af37] shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            )}
            {s.price && (
              <p className="mt-4 text-[11px] tracking-[0.2em] uppercase text-[#d4af37]" data-testid={`service-price-${s.slug}`}>
                {s.price}
              </p>
            )}
            <button
              onClick={() => onBook(s.slug)}
              data-testid={`book-service-${s.slug}`}
              className="mt-8 self-start flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-[#d4af37] hover:gap-5 transition-all duration-300"
            >
              Book this service
              <ArrowRight size={13} />
            </button>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
